import React, { useEffect, useRef } from "react";
import Modal from "../../Modal";

export default function ModalNotSubscribe(props) {
  const modalRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        props.onClose();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [props.onClose]);
  return (
    <Modal addClass="modalCamp userNotSubscribe" close={props.onClose}>
      <div ref={modalRef} className="filterModal modal__camp">
        <div className="modal__assetDetail-delete perm long lock-feture-screen">
          <h4 className="text-lg font-bold">
            This feature is available with a subscription. Upgrade now to enjoy
            full access
          </h4>
          <div className="dropdown-item !mt-2">
            <div className="unlock-box">
            <div className="modal-ref-img text-6xl text-center">
              🔓
            </div>
            </div>
            <p>
              Power up your influencer game with the perfect plan for your brand
              or agency.
            </p>
          </div>
          <div className="modal__assetDetail-delete-btns" >
            <button
              className="button primary !p-4 !text-sm"
              onClick={props.goToPricing}
            >
              Subscribe Now
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
